<template>
    <v-row class="ma-0">
        <view-user :user-id="selectedUser"
                    v-model="viewUserDialog"
                    @clearUserIdAndAuths="selectedUser = ''"
                    @getUsers="getUsersOfSpecificList()"/>

        <delete-user v-model="viewDeleteUserDialog"
                     :user="selectedUserForDelete"
                     @updateListsPersons="getUsersOfSpecificList()"
                     @clearSelectedUser="selectedUserForDelete = ''"></delete-user>
        <v-col class="text-right" cols="12" >
            <!--<input type="file" style="display: none" ref="fileInput" accept=".csv,.xlsx,xls" @change="onFilePicked">-->
        </v-col>
        <v-col cols="12">
            <v-text-field v-model="searchUsersList"
                          color="kbDarkBlueText"
                          :placeholder="$t('general.search')"
                          append-icon="search"
                          clearable>
            </v-text-field>
        </v-col>
        <v-col class="pa-0 text-h6" cols="12" >
            <v-data-table :must-sort="false"
                          :headers="headers"
                          :items="usersList"
                          class="elevation-2"
                          :loading="loadingUsersList"
                          :options.sync="options"
                          :footer-props="{
                            'items-per-page-text': `${$t('general.people')} ${$t('general.perPage')}`,
                            'items-per-page-options': [50, 100, 200]
                          }"
                          :server-items-length="totalUsersList">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-center">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-avatar v-on="on" v-if="item.isInvited && !item.verified" style="cursor: pointer;"  color="orange" size="10"></v-avatar>
                            </template>
                            <span v-if="item.isInvited && !item.verified">{{ $t('general.invited') }}</span>
                            <template v-slot:activator="{ on }">
                              <v-avatar v-on="on" v-if="!item.isInvited || item.verified" style="cursor: pointer;" :color="item.verified ? 'success' : 'error'" size="10"></v-avatar>
                            </template>
                            <span v-if="!item.isInvited || item.verified">{{item.verified ? $t('general.verified') : $t('general.notVerified')}}</span>
                        </v-tooltip>
                    </td>

                    <td class="font-weight-bold">{{ item.name }}</td>

                    <td>{{ item.email || item.phone.number }}</td>

                    <td>{{ item.receivesId }}</td>

                    <td class="px-0 mx-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                        <v-btn icon @click="showUser(item)" color="primary" text>
                            <v-icon color="kbDarkBlueText">remove_red_eye</v-icon>
                        </v-btn>

                        <v-btn v-if="list.type === 'static'" icon @click="showDeleteUser(item)" color="primary" text>
                            <v-icon color="kbRed">delete</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>

                <template v-slot:no-data>
                    <v-row>
                        <v-col class="text-center" cols="12" v-if="loadingUsersList">
                            {{ $t('general.loadingPeopleOfTheList') }}
                        </v-col>
                        <v-col cols="12" class="red--text text-center" v-else>
                            {{ $t('general.noPeopleInThisList') }}
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
// import notifications from '@/libs/notifications'
import DeleteUser from '@/pages/App/Communications/ListsPersons/dialogs/DeleteUser.vue'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser'
import { mapState } from 'vuex'
export default {
  components: { ViewUser, DeleteUser },
  computed: {
    ...mapState({
      language: state => state.auth.language,
      usersList: state => state.listsPersons.usersList,
      totalUsersList: state => state.listsPersons.totalUsersList
    }),
    searchUsersList: {
      get () {
        return this.$store.state.listsPersons.searchUsersList
      },
      set (value) {
        this.$store.commit('SET_SEARCH_USERS_LIST', value)
      }
    }
  },
  data () {
    return {
      headers: [
        { text: '', align: 'left', sortable: false },
        { text: this.$t('general.name'), align: 'left', sortable: false },
        { text: this.$t('general.emailOrPhone'), align: 'left', sortable: false },
        { text: 'ID', align: 'left', sortable: false },
        { text: this.$t('general.actions'), align: 'center', sortable: false }
      ],
      loadingUsersList: false,
      options: {},
      selectedUser: '',
      selectedUserForDelete: '',
      viewUserDialog: false,
      viewDeleteUserDialog: false
    }
  },
  methods: {
    getUsersOfSpecificList () {
      this.$store.commit('SET_PAGINATION_USERS_LIST', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getUsersOfSpecificList', { listId: this.$route.params.listid })
    },
    showDeleteUser (user) {
      this.selectedUserForDelete = user
      this.viewDeleteUserDialog = true
    },
    showUser (user) {
      this.selectedUser = user.receivesId
      this.viewUserDialog = true
    }
  },
  props: {
    list: {
      type: Object,
      required: true
    }
  },
  watch: {
    language () {
      this.headers[1].text = this.$t('general.name')
      this.headers[2].text = this.$t('general.emailOrPhone')
      this.headers[4].text = this.$t('general.actions')
    },
    options: {
      handler () {
        this.getUsersOfSpecificList()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    searchUsersList () {
      this.options.page = 1
      this.getUsersOfSpecificList()
    }
  }
}
</script>
